import React from "react";
import { connect } from 'react-redux'
const Rating = (props) => {
  return (
    <div className="betterview">
      <button onClick={()=>{props.dispatch({type:'UPDATERATING',payload:1})}}>
        1 star
      </button>&nbsp;&nbsp;
      <button onClick={()=>{props.dispatch({type:'UPDATERATING',payload:2})}}>2 star</button>&nbsp;&nbsp;
      <button onClick={()=>{props.dispatch({type:'UPDATERATING',payload:3})}}>3 star</button>&nbsp;&nbsp;
      <button onClick={()=>{props.dispatch({type:'UPDATERATING',payload:4})}}>4 star</button>&nbsp;&nbsp;
      <button onClick={()=>{props.dispatch({type:'UPDATERATING',payload:5})}}>5 star</button>&nbsp;&nbsp;
    </div>
  );
};
export default connect((store)=>{return store})(Rating);